/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum InternalState {
  None = 'none',
  Waiting = 'waiting',
  Deferred = 'deferred',
  Ignored = 'ignored'
}
